import { Snackbar } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const toastStyles = {
  info: { bg: "#E8F1FF", color: "#1E3A8A" },
  success: { bg: "#DCFCE7", color: "#166534" },
  error: { bg: "#FEE2E2", color: "#991B1B" },
  warning: { bg: "#FEF9C3", color: "#854D0E" },
};

const SimpleSnackbar = ({
  message,
  color = "info",
  isMessage = false,
  client__id = null,
  isloading= false
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (message) setOpen(true);
  }, [message]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const isError = color === "error";

  return (
    <Snackbar
      open={open}
      autoHideDuration={3500}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{
        top: "env(safe-area-inset-top, 12px)",
      }}
    >
      <div
        onClick={() => {
          if (isMessage && client__id) {
            navigate(`/dashboard/patient/${client__id}`);
          }
        }}
        className="
          flex items-center gap-2
          px-4 py-2.5
          rounded-full
          shadow-lg
          text-sm font-medium
          max-w-[92vw]
          transition-all duration-200
          active:scale-95
        "
        style={{
          backgroundColor: toastStyles[color]?.bg,
          color: toastStyles[color]?.color,
          cursor: isMessage ? "pointer" : "default",
        }}
      >
        {isError || isloading && (
          <Loader2 size={16} className="animate-spin opacity-80" />
        )}

        <span className="truncate">{message}</span>
      </div>
    </Snackbar>
  );
};

export default SimpleSnackbar;